import { useEffect, useState } from "react";
import api from "../services/apis";
import { DEMO_DATA } from "../utils/demoData";
const useUsageLimits = (code) => {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const demo = DEMO_DATA[code];

  useEffect(() => {
    if (demo) return;
    if (!code) {
      setLoading(false);
      return;
    }

    let isMounted = true;
    setLoading(true);
    setError(null);

    api.get(`api/v1/coupon/${code}/usage-limits`)
      .then((res) => {
        if (!isMounted) return;
        setUsage(res.data?.data ?? null);
      })
      .catch((err) => {
        if (!isMounted) return;
        setError(err);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [code]);
   if (demo) return { usage: demo.usage, loading: false, error: null };
  return { usage, loading, error };
};
 

export default useUsageLimits;